import { render, staticRenderFns } from "./WDemergencyContact.vue?vue&type=template&id=4e7db10a&scoped=true"
import script from "./WDemergencyContact.vue?vue&type=script&lang=js"
export * from "./WDemergencyContact.vue?vue&type=script&lang=js"
import style0 from "./WDemergencyContact.vue?vue&type=style&index=0&id=4e7db10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7db10a",
  null
  
)

export default component.exports